import { Fragment } from 'react';
import { DocumentsItemsTypes } from '../types';
import DocumentRow from './document-row';

import cn from '../styles.module.css';

const DocumentsItems = ({
  documents,
  onSelect,
  type,
  customerId,
  customerType,
  setRenamePopupVisible,
  setSelectedDocumentToRename,
  status,
  updateExpiredDocumentsState,
}: DocumentsItemsTypes): React.JSX.Element => (
  <div
    className={`
    ${cn.documentsItemsWrapper} 
   `}
  >
    {documents?.map((item) => (
      <Fragment key={item.id}>
        <DocumentRow
          document={item}
          onSelect={onSelect}
          type={type}
          lastChild={Boolean(documents.length === 1)}
          customerId={customerId}
          customerType={customerType}
          setRenamePopupVisible={setRenamePopupVisible}
          setSelectedDocumentToRename={setSelectedDocumentToRename}
          status={status}
          updateExpiredDocumentsState={updateExpiredDocumentsState}
        />
      </Fragment>
    ))}
  </div>
);

export default DocumentsItems;
